export default {
  name: 'nuxt-link',
  functional: true,
  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    return h('router-link', data, children);
  }
};


//////////////////
// WEBPACK FOOTER
// ./.nuxt/components/nuxt-link.js
// module id = ./.nuxt/components/nuxt-link.js
// module chunks = 152